<template>
  <div class="modal" tabindex="-1" role="dialog" id="impersonate" style="display: block; padding-right: 17px;">
    <div class="modal-mask" @click.self="$emit('impersonateModal', false)">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Impersonate as</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" @submit.prevent="handleSubmit">
            <form class="form-row justify-content-center">
              <div class="col-md">
                <div v-bind:class="{'form-group':true , 'mb-0':true}">
                  <div class="input-group">
                    <input type="text" v-model="email" class="form-control" placeholder="crew's email" @keyup="toLower">
                    <div class="input-group-append">
                      <span class="input-group-text">{{emailDomain}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <form class="form-row justify-content-end mt-3">
              <div class="col-auto align-self-end">
                <a href="#" class="btn btn-primary" data-dismiss="modal" @click="resetSubmit">Reset</a>
              </div>
              <div class="col-auto align-self-end">
                <a href="#" class="btn btn-primary" data-dismiss="modal" @click="handleSubmit">Search</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    email:'',
    emailDomain:'@starlux-airlines.com',
    originalEmail: localStorage.getItem('mail'),
  }),
  methods: {
    closeModal () {
      this.$emit('impersonateModal', false)
    },
    handleSubmit() {
      let email = this.email.concat(this.emailDomain)
      this.$store.dispatch("setImpersonateMail", email)
      this.$emit('impersonateModal', false)
    },
    resetSubmit() {
      let email = this.originalEmail
      this.email = this.originalEmail.split('@')[0]
      this.$store.dispatch("setImpersonateMail", email)
      this.$emit('impersonateModal', false)
    },
    toLower (val) {
      this.email = val.target.value.toLowerCase()
    }
  }
}
</script>
